module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h1', {
    staticClass: "ack"
  }, [_vm._v("List of maps")]), _vm._v(" "), _c('p', {
    staticClass: "nonindentj"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/fm#mapvii"
    }
  }, [_vm._v("Europe under Nazi rule")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindentj"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01#map26-1"
    }
  }, [_vm._v("The four death camps")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindentj"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c04#map41-1"
    }
  }, [_vm._v("The Bund Report of May 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindentj"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c08#map79-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The ‘Teheran children’")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindentj"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c10#map89-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The first eye-witnesses arrive")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindentj"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c21#map191-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First flight over Auschwitz")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindentj"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c21#map193-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Auschwitz-Birkenau-Monowitz region")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindentj"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c21#map195-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Birkenau")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindentj"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c21#map197-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The escapees reach Slovakia")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindentj"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c24#map213-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Brand mission")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindentj"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c24#map221-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Operation Frantic, June 1944")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindentj"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c26#map247-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Railway routes and the bombing appeal")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindentj"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c26#map252-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The truth about Auschwitz reaches the West")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindentj"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c29#map283-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Allied bomber raids, July 1944")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindentj"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c31#map302-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Operation Frantic, August 1944")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindentj"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c31#map306-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Allied bomber raids, August 1944")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindentj"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c31#map307-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Allied bomber targets in the Auschwitz region")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindentj"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c32#map316-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An air reconnaissance sortie over Auschwitz, 16 September 1944")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindentj"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c32#map318-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Allied bombing targets during September 1944")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindentj"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c32#map323-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Allied airborne aid to Poland, September 1944")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e294f946","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/limap.vue
// module id = 78
// module chunks = 0